import { schema } from "normalizr";
class EntityKeysMapper {
  separator = "_._";
  schemaMapper;
  _entityTypes;
  constructor(mapper, entityTypes) {
    this.schemaMapper = mapper;
    this._entityTypes = entityTypes;
  }
  getUniqueKeyObjects(entity, type) {
    const result = [];
    const schemaDefinition = this.schemaMapper.getSchemaDefinitions(type);
    const entitySchema = this.schemaMapper.getSchema(type);
    const id = entitySchema.getId(entity, null, null);
    if (id !== null && id !== void 0) {
      result.push(this.getUniqueKey(type, id));
    }
    if (entity) {
      result.push(...this.getNestedKeys(entity, Object.keys(entity), schemaDefinition));
    }
    return result.map((key) => this.mapToObjectKey(key));
  }
  getUniqueKeyStrings(entity, type) {
    return this.getUniqueKeyObjects(entity, type).map((key) => this.getUniqueKey(key.type, key.id));
  }
  mapToStringKey(key) {
    return this.getUniqueKey(key.type, key.id);
  }
  mapToObjectKey(key) {
    let res;
    if (key?.length) {
      const splittedKey = key.split(this.separator);
      if (splittedKey.length === 2 && this._entityTypes.includes(splittedKey[0])) {
        res = {
          type: splittedKey[0],
          id: splittedKey[1]
        };
      }
    }
    return res;
  }
  getNestedKeys(parent, fields, schemaDefinition) {
    const result = [];
    fields.forEach((field) => {
      const value = parent[field];
      const nestedDefinition = schemaDefinition?.[field];
      if (nestedDefinition instanceof schema.Entity) {
        const type = nestedDefinition.key;
        result.push(this.getUniqueKey(type, value));
      } else if (Array.isArray(nestedDefinition) && nestedDefinition.length && nestedDefinition[0] instanceof schema.Entity) {
        const type = nestedDefinition[0].key;
        const uniqueKeys = value?.map((id) => this.getUniqueKey(type, id)) ?? [];
        result.push(...uniqueKeys);
      } else if (nestedDefinition instanceof Object && value) {
        result.push(...this.getNestedKeys(value, Object.keys(value), nestedDefinition));
      }
    });
    return result;
  }
  getUniqueKey(type, id) {
    return `${type}${this.separator}${id}`;
  }
}
export {
  EntityKeysMapper
};
//# sourceMappingURL=schemas.js.map
